// extracted by mini-css-extract-plugin
module.exports = {"container":"historyModal_container__I9_n8","tabs":"historyModal_tabs__4LcFi","tabButton":"historyModal_tabButton__p_ipd"};